import React, { Component } from 'react';
import { connect } from 'react-redux';
import './updateProfile.scss';
import { Button, message } from 'antd';
import NoImage from "../../../images/no-image.jpg";
import EditIcon from "../../../images/edit-icon.png";
import { saveResidentialAdress, uploadResidentialAdress, approveRejectUserDocument, approveRejectResidentileDetail } from '../action/user.actions'
import { fromValidate } from '../../../helpers';
import _ from 'lodash';
import { imageEndpoint } from '../../../services/endpoint';

class ResidentileDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      residential_address: {},
      document: {},
      doc: {},
      user_residential_address: {}

    }
  }

  componentDidMount() {
    const { user } = this.props;
    this.setState({ residential_address: user.residential_address }, () => {
      this.getLocation();
    });

  }
  componentWillReceiveProps(props){
    const { user, userDetails } = props;
    const user_residential_address = user.role.name == 'Admin' ? (userDetails.residential_address ) || [] : (user.residential_address ) || [];
    const document = user.role.name == 'Admin' ? (userDetails.residential_address && userDetails.residential_address.documents) || [] : (user.residential_address && user.residential_address.documents) || [];
    const doc = _.first(document)
    this.setState({ doc:doc, user_residential_address: user_residential_address });
  }

  handleChange = (e) => {
    const residential_address = Object.assign({}, this.state.residential_address)
    const name = e.target.name;
    const value = e.target.value;
    residential_address[name] = value;
    this.setState({ residential_address });
  }

  createFormData = (body) => {
    let data = new FormData();
    Object.keys(body).forEach(key => {
      data.append(key, body[key]);
    });
    return data;
  };

  onSelectFile = (e) => {
    const { user } = this.props;
    const document = Object.assign({}, this.state.document)
    let file = e.target.files[0];
    if (file) {
      document.photo = file;
      document.user_id = user.id;
      document.document_type = file.type;
      document.document_name = document.document_name || 'House Rent Agreement';
      this.setState({ document: document })
    }
    // dispatch(uploadIdentityverification(user.id, formData))
  }

  onSelectDocumentName = (e) => {
    const document = Object.assign({}, this.state.document);
    document.document_name = e.target.value;
    this.setState({ document: document })
  }

  getLocation = () => {

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const residential_address = Object.assign({}, this.state.residential_address)
        residential_address.location_latitude = position.coords.latitude;
        residential_address.location_longitude = position.coords.longitude;
        this.setState({ residential_address });
      });
    }
  }

  saveResidentialAddress = (e) => {
    const { user, dispatch } = this.props;
    let { residential_address, document } = this.state;
    e.preventDefault();
    this.setState({ formError: {}, formSubmit: true })
    const formValidation = fromValidate(e.target);
    if (!formValidation.valid) {
      this.setState({ formError: formValidation.invalidationEle })
    }
    else {

      if (_.get(residential_address, 'location_latitude')) {
        let req = {
          "user_id": user.id,
          "address_line1": residential_address.address_line1,
          "address_line2": residential_address.address_line2,
          "city": residential_address.city,
          "state": residential_address.state,
          "country": residential_address.country,
          "zip": residential_address.zip,
          "location_latitude": residential_address.location_latitude,
          "location_longitude": residential_address.location_longitude
        };
        dispatch(saveResidentialAdress(user.id, req))
          .then((res) => {
            if (document) {
              let fromData = this.createFormData(document)
              dispatch(uploadResidentialAdress(user.id, fromData))
            }
          });
      } else {
        message.error(`Please locate yourself before saving the address!`);
      }
    }
  }
  
  approveRejectUserDocument = (id, status) => {
    const {dispatch, user} = this.props;
    const data = {
      document_id: id,
      status: status
    }
    dispatch(approveRejectUserDocument(data, user.id)).then((res) => {
      let doc = [...this.state.doc];
      let currentDoc = doc.find(e => e.id == id);
      currentDoc.status = status == "V" ? "Verified" : "Rejected";
      this.setState({document: doc})
    })
    .catch((err) => {
      console.log(err);
    });
  }
  approveRejectResidentileDetail = (id, status) =>{
    const {dispatch} = this.props;
    const data = {
      user_id: id,
      status: status
    }
    dispatch(approveRejectResidentileDetail(data)).then((res)=>{
      let doc = this.state.user_residential_address;
      doc.status = status == "V" ? "Verified" : "Rejected";
      this.setState({user_residential_address: doc})
    })
    .catch((err) => {
      console.log(err);
    })
  }

  render() {
    const { user, userDetails } = this.props;
    const role = user.role.name;
    const { residential_address } = this.state;
    const document = role == 'Admin'? (userDetails.residential_address && userDetails.residential_address.documents) || []: (user.residential_address && user.residential_address.documents) || [];
    const {doc, user_residential_address} = this.state;

    return (
      <div className="form-main-cont-box">
        <div className="upprof-heading-txt">Residentile Detail
          {
            role == "Admin" && 
            <span className='verification-button-container'>
              <Button type="button"  disabled={user_residential_address.status === "Verified"} className="ant-btn btn-login" onClick={() => { this.approveRejectResidentileDetail(userDetails.id, 'V')}} ><span>{user_residential_address.status == "V"? "Approved" : "Approve Residentile Detail"}</span></Button>
              <Button type="button" disabled={user_residential_address.status === "Rejected"} className="ant-btn btn-reject" onClick={() => { this.approveRejectResidentileDetail(userDetails.id, 'R')}}><span>{user_residential_address.status == "R"? "Rejected": "Reject Residentile Detail"}</span></Button>
            </span>
          }
        </div>
        <form ref={node => this.fromNode = node} noValidate autoComplete="off" onSubmit={(e) => { this.saveResidentialAddress(e) }}>

          <div className="row row-padding">
            <div className="col-sm-12 col-md-8 col-xs-12">
              {
                role == "Admin" && 
                <div>
                  <div><label>{residential_address.address_line1}</label></div>
                  <div><label>{residential_address.address_line2}</label></div>
                </div>
              }{
                role != "Admin" && 
                <div>
                  <input
                    type="text"
                    required
                    className='prof-textfield-containt'
                    placeholder="Address 1"
                    name="address_line1"
                    value={residential_address.address_line1}
                    onChange={(e) => { this.handleChange(e) }}
                  />
                  <input
                    type="text"
                    className='prof-textfield-containt'
                    placeholder="Address 2"
                    name="address_line2"
                    value={residential_address.address_line2}
                    onChange={(e) => { this.handleChange(e) }}
                  />
                </div>
              }
              <div className="row">
                <div className="col-sm-12 col-md-6 col-xs-12">
                  {
                    role == "Admin" && 
                    <label>{residential_address.city}</label>
                  }{
                    role != "Admin" && 
                    <input
                      type="text"
                      required
                      className='prof-textfield-containt'
                      placeholder="City"
                      name="city"
                      value={residential_address.city}
                      onChange={(e) => { this.handleChange(e) }}
                    />
                  }
                </div>
                <div className="col-sm-12 col-md-6 col-xs-12">
                  {
                    role == "Admin" && 
                    <label>{residential_address.state}</label>
                  }{
                    role != "Admin" && 
                    <input
                      type="text"
                      className='prof-textfield-containt'
                      placeholder="State"
                      required
                      name="state"
                      value={residential_address.state}
                      onChange={(e) => { this.handleChange(e) }}
                    />
                  }
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-6 col-xs-12">
                  {
                    role == "Admin" && 
                    <label>{residential_address.country}</label>
                  }{
                    role != "Admin" && 
                    <input
                      type="text"
                      className='prof-textfield-containt'
                      placeholder="Country"
                      name="country"
                      required
                      value={residential_address.country}
                      onChange={(e) => { this.handleChange(e) }}
                    />
                  }
                </div>
                <div className="col-sm-12 col-md-6 col-xs-12">
                  {
                    role == "Admin" && 
                    <label>{residential_address.zip}</label>
                  }{
                    role != "Admin" &&
                    <input
                      type="text"
                      className='prof-textfield-containt'
                      placeholder="Zip"
                      name="zip"
                      required
                      value={residential_address.zip}
                      onChange={(e) => { this.handleChange(e) }}
                    />
                  }
                </div>
              </div>

              <div className="row">
                <div className="col-12">
                  {
                    role != "Admin" && 
                    <Button htmlType="button"
                    onClick={() => { this.getLocation() }}
                    className='btn-login'>Locate me</Button>
                  }
                    ({residential_address.location_latitude},
                    {residential_address.location_longitude})
                </div>
              
              </div>

            </div>
            <div className="col-sm-12 col-md-4 col-xs-12">
              <div>
                <div className="doc-img-box">
                  <div>
                    {
                      role == "Admin" &&
                      <label>{document.document_name}</label>
                    }{
                      role != "Admin" &&
                      <select
                        className='prof-textfield-containt'
                        placeholder="DocumentType"
                        required
                        value={document.document_name}
                        name="document_name" onChange={(e) => { this.onSelectDocumentName(e) }}>
                        <option value="House Rent Agreement">House Rent Agreement</option>
                        <option value="Tax Bill / Gas Bill / Electicity Bill / Telephone Bill">Tax Bill / Gas Bill / Electicity Bill / Telephone Bill</option>
                        <option value="House Image">House Image</option>
                      </select>
                    }
                  </div>
                  <div className="upload-btn-wrapper">
                    <img src={EditIcon} className="doc-edit-icon" alt="" />
                    <input type="file" name="myfile" onChange={(e) => { this.onSelectFile(e) }} />
                  </div>
                  <img src={doc && doc.document_url ? imageEndpoint + doc.document_url : NoImage} className="update-prof-img-box" alt="" />
                </div>
                <label className="redio-lavel-txt" >Upload Document</label>
                {
                  role == "Admin" &&
                  <div>
                    <Button type="button"  disabled={ doc && doc.status === "Verified"} className="ant-btn btn-login" onClick={() => {this.approveRejectUserDocument(doc.id, 'V')}}><span>{ doc && doc.status == "Verified" ? 'Approved' : "Approve"}</span></Button>
                    <Button type="button" disabled={ doc && doc.status === "Rejected"} className="ant-btn btn-reject" onClick={() => {this.approveRejectUserDocument(doc.id, 'R')}}><span>{ doc && doc.status == "Rejected" ? 'Rejected' : "Reject"}</span></Button>
                  </div>
                }
              </div>
            </div>
          </div>
          {
            role != "Admin" &&
            <div>
              <Button htmlType="submit" className='btn-login'>SAVE</Button>
            </div>
          }
          
        </form>
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  }
}
export default connect(mapStateToProps)(ResidentileDetail);